/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from 'react'
import { FolderIcon, Trash, TrashGradient } from "../../../Components/LandingHeader/Feedback/icons/Icons";
import { Modal } from "react-bootstrap";
import { deleteProject } from "../../../Components/action/tasks";
import TaskSourceIcon from "../../Tasks/TaskSourceIcon";

const DeleteProjectModal = ({onHide, theme, project}) => {
    const projectTitle = project.title.replaceAll('_', ' ');

    const deleteProjectHandler = async (e, deleteTasks = false) => {
        e.preventDefault()
        e.stopPropagation()
        
        try{
            await deleteProject(project.project_id, deleteTasks)
            onHide(true, project.project_id)
        }catch(err){
            console.log(err)
        }
    }

    return (
        <Modal show={true} onHide={onHide} className="task-modal">
            <Modal.Body className='modal-body-extra-padding'>
            <div className="full-model md-model-updates block">
                <div className="full-model-body">
                    <div className="body-data">
                        <div className='ctTitle relative flex-col justify-start gap-5 items-start'>
                            <div className='flex items-center justify-start gap-[10px]'>
                                <TrashGradient color={"var(--accent-color)"} fill={"var(--accent-color)"} />
                                <span className='darkPrimaryColor'>Are you sure you want to delete this project?</span>
                            </div>
                            <p className='font text-[14px] opacity-50 text-black dark:text-white font-inter'>This cannot be undone.</p>
                        </div>
                        <div className='flex py-[30px] px-10 gap-5 justify-center items-center w-full'>
                            <div className='flex flex-col gap-[10px]'>
                                <div className='flex items-center justify-start gap-[10px] text-black dark:text-white'>
                                    <FolderIcon width={18} height={18} color={"black"} fill={"none"} /> {projectTitle} <span className="mn-count" style={{ color: theme == "dark" ? "gray" : "" }}></span>
                                </div>
                                <div className='flex items-center justify-start gap-[10px]'>
                                    <TaskSourceIcon task={{id: project.project_id, taskSource: project.projectSource}} />
                                    <p className='font text-[14px] opacity-50 text-black dark:text-white font-inter'>{project.completedTasksCount} / {project.pendingTasksCount + project.completedTasksCount} Tasks pending</p>
                                </div>
                            </div>
                            <span style={{flex: '1 0 0px', alignSelf: 'stretch'}}></span>
                            <button className='btn btn-primary font-inter bg-white dark:bg-black' onClick={onHide}><span className="darkPrimaryColor">Cancel</span></button>
                            <button className='btn btn-primary font-inter' onClick={e => deleteProjectHandler(e, true)} css={{
                                background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.90) 0%, rgba(var(--theme-mode-rgb-white), 0.90) 100%), var(--accent-color) !important`
                            }}><span className="darkPrimaryColor">Delete Project & Tasks</span></button>
                            <button className='btn btn-primary font-inter' onClick={e => deleteProjectHandler(e, false)} css={{background: `var(--accent-color) !important`}}><span className="text-white">Delete Project</span></button>
                        </div>
                    </div>
                </div>
            </div>
            </Modal.Body>
        </Modal>
    )
}

export default DeleteProjectModal;